/**
 * RequireRole Guard
 * 
 * Ensures user has minimum required role level.
 * Returns null during loading, Navigate on failure, children on success.
 */

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

export type Role = 'viewer' | 'editor' | 'admin' | 'owner';

const roleHierarchy: Record<Role, number> = {
  viewer: 1,
  editor: 2,
  admin: 3,
  owner: 4,
};

export interface RequireRoleProps {
  children?: ReactNode;
  minRole: Role;
  userRole: Role | null;
  loading: boolean;
  redirectTo?: string;
}

export function RequireRole({
  children,
  minRole,
  userRole,
  loading,
  redirectTo = '/app/dashboard',
}: RequireRoleProps) {
  if (loading) {
    return null;
  }

  if (!userRole || roleHierarchy[userRole] < roleHierarchy[minRole]) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
